import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DistrictSurveyService {
  private apiUrl = environment.apiUrl + '/district_surveys/';
  private http = inject(HttpClient);

  get(periodId?: string): Observable<any> {
    let params = new HttpParams();
    if (periodId) params = params.set('period', periodId);
    return this.http.get(this.apiUrl + 'get', { params });
  }

  getFiltered(filters: { periodId?: string; districtId?: string; churchId?: string }): Observable<any> {
    let params = new HttpParams();
    if (filters.periodId) params = params.set('period', filters.periodId);
    if (filters.districtId) params = params.set('district', filters.districtId);
    if (filters.churchId) params = params.set('church', filters.churchId);
    return this.http.get(this.apiUrl + 'get', { params });
  }

  generateExcel(filters: { periodId?: string; districtId?: string; churchId?: string }): Observable<Blob> {
    let params = new HttpParams();
    if (filters.periodId) params = params.set('period', filters.periodId);
    if (filters.districtId) params = params.set('district', filters.districtId);
    if (filters.churchId) params = params.set('church', filters.churchId);
    return this.http.get(this.apiUrl + 'generateExcel', { params, responseType: 'blob' });
  }

  checkCompletion(userId: string, periodId: string): Observable<any> {
    const params = new HttpParams().set('userId', userId).set('periodId', periodId);
    return this.http.get(this.apiUrl + 'checkCompletion', { params });
  }

  getById(id: string): Observable<any> {
    return this.http.get(this.apiUrl + 'get/' + id);
  }

  save(surveyData: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save', surveyData);
  }

  update(id: string, surveyData: any): Observable<any> {
    return this.http.put(this.apiUrl + 'update/' + id, surveyData);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(this.apiUrl + 'delete/' + id);
  }
}
